import { render, staticRenderFns } from "./FullServicePosts.vue?vue&type=template&id=68c48e0c&scoped=true&"
import script from "./FullServicePosts.vue?vue&type=script&lang=js&"
export * from "./FullServicePosts.vue?vue&type=script&lang=js&"
import style0 from "./FullServicePosts.vue?vue&type=style&index=0&id=68c48e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c48e0c",
  null
  
)

export default component.exports